import React, { useEffect, useRef, useState } from 'react';
import { FilterContainer, FilterHeader, PageTitle } from 'resources/styles/TableStyle';

import styled, { createGlobalStyle } from 'styled-components';
import { Button as SaladButton, Row, Select, InputField } from 'saladsoft-primitive';
import { TextField } from '@mui/material';
import { ReservationPeriodFilterType } from 'types/CommonTypes';

import { observer } from 'mobx-react-lite';
import { getUrlParam } from 'libs/helper/utils';
import { setUrlParams, deleteUrlParams } from 'libs/helper/paramsUtil';
import Button from 'components/input/NewButton';
import SearchBox from 'components/input/SearchBox';
import SaladToggleButton from 'components/input/SaladToggleButton';
import ServiceHelper from 'stores/ServiceHelper';

import TableHeader from '../tables/TableHeader';
const GlobalInputStyle = createGlobalStyle`
  .MuiOutlinedInput-input {
    padding: 6px !important;
  }
`;

const UserCouponFilter = observer(({ onClickAdd }: { onClickAdd: (quantity: number) => void }) => {
  const items = [
    { value: '', label: '전체' },
    { value: 'OPEN', label: '가능' },
    { value: 'USED', label: '완료' },
    { value: 'EXPIRED', label: '만료' },
  ];

  const [periodType, setPeriodType] = useState<ReservationPeriodFilterType['periodType']>('ALL');
  const [isSearched, setIsSearched] = useState<boolean>(false);
  const [statusIndex, setStatusIndex] = useState<number>();
  const [couponId, setCouponId] = useState<string>('');
  const [couponName, setCouponName] = useState<string>('');
  const [isValid, setIsValid] = useState<boolean>(false);
  const [quantity, setQuantity] = useState<number>();

  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [itemIndex, setItemIndex] = useState<number>();

  const [voucherCategories, setVoucherCategories] = useState<Record<string, any>[]>([]);

  const getVoucherCategory = () => {
    ServiceHelper?.adminCouponService?.getCoupons({ size: 1000 }).then((res) => {
      if (couponId !== '') {
        setCouponName(
          res.data.filter((item) => item.id?.toString() === couponId)[0]?.localizedName?.ko || '',
        );
      }
      setVoucherCategories([
        ...res.data.map((item) => ({
          key: item.id?.toString(),
          value: item.localizedName?.ko || '',
        })),
      ]);
    });
  };

  useEffect(() => {
    getVoucherCategory();
    const search = getUrlParam('search');
    const couponId = getUrlParam('couponId');
    const status = getUrlParam('status');
    if (search) {
      setIsSearched(true);
    } else {
      setIsSearched(false);
    }

    if (status) {
      setStatusIndex(items.findIndex((item) => item.value === status));
    }
    setSearchKeyword(search || '');
    setCouponId(couponId || '');
    setCouponName(couponName || '');
  }, [location.search]);

  useEffect(() => {
    setIsValid(couponId !== '');
  }, [couponId]);

  /** 만약 특정 SaladToggleButton을 사용할 경우, 파라미터를 검사하여 해당 값을 기본값으로 전달한다. */
  useEffect(() => {
    const periodType = getUrlParam('periodType');
    setItemIndex(periodType ? items.findIndex((item) => item.value === periodType) : 0);
  }, [periodType]);

  return (
    <div>
      <GlobalInputStyle />
      {/* <Row width="100%" justifyContent="flex-start" alignItems="center" gap={10} marginTop="20px">
        <Text type="H3" style={{ fontWeight: 700, color: 'var(--point-color)' }}>바우처</Text>
        <div style={{ fontSize: 12, color: '#666666' }}>바우처 목록 <span style={{ padding: '0 2px' }}>/</span> {voucherCategoryName}</div>
      </Row> */}

      <Row justifyContent="space-between" width="100%" marginTop="10px">
        <PageTitle>사용자 쿠폰 관리</PageTitle>

        <FilterContainer>
          <Select
            items={voucherCategories}
            containerStyle={{ border: '1px solid #d9d9d9' }}
            useRound={false}
            itemBoxStyle={{ maxHeight: 300, overflowY: 'auto' }}
            defaultKey={couponId}
            onChange={(value) => {
              setUrlParams({
                couponId: value.key,
                page: '1',
                status: '',
              });
            }}
          />
          {couponId !== '' && (
            <>
              <SaladToggleButton
                defaultIndex={statusIndex}
                items={items}
                onChange={(value) => {
                  setUrlParams({
                    status: value,
                    page: '1',
                  });
                }}
              />
              <SearchBox paramKey="searchKeyword" placeholder="쿠폰코드" />
            </>
          )}
        </FilterContainer>
        <div>
          <Row
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            gap={10}
            paddingTop="10px"
          >
            <Row gap={5}>
              <InputField
                placeholder="발행 수량"
                value={quantity}
                type="number"
                onChange={(value) => {
                  setQuantity(parseInt(value));
                }}
              />
              <Button
                isValid={quantity && quantity > 0 ? true : false}
                onClick={() => {
                  onClickAdd(quantity as number);
                  setQuantity('' as any);
                }}
              >
                사용자쿠폰 발행
              </Button>
            </Row>
          </Row>
        </div>
      </Row>
    </div>
  );
});

export default UserCouponFilter;
